module.exports = __webpack_public_path__ + "img/upsmallarrow.15e238e2.svg";